<template>
  <div class="px-4">
    <section class="max-w-6.5xl mx-auto py-18">
      <header class="flex flex-col items-center mt-2">
        <img src="/images/top-underline.svg" alt="underline" />
        <h2 class="h2 text-gray-900 font-alt mt-6">{{ title }}</h2>
        <p class="text-gray-600 mt-4 text-lg">{{ description }}</p>
      </header>

      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 air:grid-cols-4 lg:grid-cols-5 gap-x-10 gap-y-12 mt-16 -mx-[2px]"
      >
        <TeamItem v-for="item in items" :key="item.id" :item="item" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { TeamItemType } from '~/types/team-types'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  items: {
    type: Array as PropType<TeamItemType[]>,
    default: () => [],
  },
})
</script>
